import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2aacf1a4&scoped=true&lang=pug"
import script from "./script.ts?vue&type=script&lang=js&external"
export * from "./script.ts?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=2aacf1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aacf1a4",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports